<template>
<div class="bg-white">
  <b-container fluid class="bg-white pb-3">
    <b-row>
      <b-col>
        <h1>Historical prices</h1>
      </b-col>
    </b-row>
  </b-container>
  <b-container class="bg-white pb-5" v-if="!steps.loadedData" style="min-height: 100vh">
    <b-row class="mb-5" v-if="steps.schema">
      <b-col>
        <div>
          <h3>Step 1 - choose schema</h3>
          <input v-if="schema.length === 0" type="file" id="inputSchema" @change="schemaFileRegister" />
          <b-button v-if="schemaFile && schema.length === 0" @click="schemaFileProcess">Load schema</b-button>
        </div>
        <div v-if="schema.length > 0">
          <h5>Loaded schema</h5>
          <div v-for="(line, index) in schema" :key="'schema-line-' + index">
            {{line}}
          </div>
          <div>
            <b-button @click="schemaCancel">Reload schema</b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="steps.data">
      <b-col>
        <h3>Step 2 - load data</h3>
        <input v-if="!steps.loadedData" type="file" id="input"  @change="dataFileRegister" />
        <b-button v-if="file && !steps.loadedData" @click="dataFileStream">Stream</b-button>
        <div class="my-4" v-if="steps.loadingData">
          <b-spinner label="Spinning"></b-spinner>
        </div>
        <div v-if="steps.loadingData || steps.loadedData">
          processed rows of data: {{lines}}
        </div>
        <div v-if="steps.loadedData">
          <b-button v-if="file" @click="dataFileReload">Reload</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="steps.loadingData" class="my-5 py-5">
      <b-col>
        <h3>Loading data</h3>
        <div><b-spinner label="Spinning"></b-spinner></div>
        <h4>processed rows of data: {{lines}}</h4>
      </b-col>
    </b-row>
  </b-container>
  <b-container fluid v-if="steps.loadedData" style="min-height: 100vh">
    <b-row>
      <b-col>
        <div>
          <b-tabs content-class="mt-3">
            <b-tab title="Preview" active>
              <div>Records loaded: {{lines}}. A quick preview of the first 30 records</div>
              <div id="preview"></div>
              <b-button variant="danger" @click="dataFileReload">Reload - start again</b-button>
            </b-tab>
            <b-tab title="Explore">
              <b-container fluid>
                <b-row>
                  <b-col>
                    <div>
                      <div id="priceChart"></div>
                    </div>
                  </b-col>
                  <b-col>
                    <div>
                      <div id="historgramChart"></div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div>
                      <div id="spreadChart"></div>
                    </div>
                  </b-col>
                  <b-col>
                    <div>
                      <div id="violinChart"></div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div>
                      <div id="balanceChart"></div>
                    </div>
                  </b-col>
                  <b-col>
                    <div>
                      <div id="balanceSmoothChart"></div>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import * as dfd from 'danfojs/src/index.js'
import _ from 'lodash'
import async from 'async'
import parse from 'csv-parse'
import Plotly from 'plotly.js-dist'
import hljs from 'highlight.js/lib/core'
import javascript from 'highlight.js/lib/languages/javascript'

hljs.registerLanguage('javascript', javascript)

function delay (period) {
  return new Promise(resolve => {
    setTimeout(resolve, period)
  })
}

let dateTime = []
let bidPrice = []
let bidSize = []
let askPrice = []
let askSize = []
let spread = []
let balance = []

export default {
  components: {
  },
  computed: {
    symbolsSuggest: function () {
      if (this.symbolSearchInput.length > 0) {
        return this.symbols.filter(symbol => symbol.toUpperCase().includes(this.symbolSearchInput.toUpperCase())).slice(0, 20)
      }
      return []
    },
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  beforeDestroy: function () {
    this.dataFileReload()
  },
  created: function () {
    this.$stat.log({ page: 'Analytics app start', action: 'open Analytics app' })
    window.Plotly = Plotly

    this.parser = parse({
      delimiter: ','
    })

    this.parser.on('readable', async () => {
      const recordRaw = this.parser.read()
      const record = recordRaw
      let accept = true
      if (record[this.col.bidPrice] === "0") {
        accept = false
      }
      if (record[this.col.askPrice] === "0") {
        accept = false
      }
      if (accept) {
        dateTime.push(record[this.col.dateTime])
        const bidSizeT = Number(record[this.col.bidSize])
        const askSizeT = Number(record[this.col.askSize])
        const bidPriceT = Number(record[this.col.bidPrice])
        const askPriceT = Number(record[this.col.askPrice])
        const spreadT = ((askPriceT - bidPriceT) / bidPriceT) * 100
        const balanceT = bidSizeT - askSizeT
        bidSize.push(bidSizeT)
        askSize.push(askSizeT)
        bidPrice.push(bidPriceT)
        askPrice.push(askPriceT)
        spread.push(spreadT)
        balance.push(balanceT)
        if (this.headCounter < 30) {
          this.headData.push(record)
        }
        this.headCounter += 1
      }
    })
  },
  data () {
    return {
      completed: false,
      col: {},
      file: null,
      headCounter: 0,
      headData: [],
      lines: 0,
      parser: null,
      reader: null,
      schema: [],
      schemaFile: null,
      schemaFileContent: null,
      show: false,
      steps: {
        schema: true,
        data: false,
        loadingData: false,
        loadedData: false
      }
    }
  },
  methods: {
    analyticsPrepare: async function () {
      await delay(50)
      const df = new dfd.DataFrame(this.headData, { columns: this.schema })
      const config = {
        layout: {
          height: 800,
          margin: {
            l: 10,
            r: 10,
            b: 10,
            t: 10,
            pad: 2
          }
        }
      }
      df.plot('preview').table(config)
      const traceBid = { x: dateTime, y: bidPrice, type: 'scatter', name: 'Bid' }
      const traceAsk = { x: dateTime, y: askPrice, type: 'scatter', name: 'Offer' }
      const layoutPrice = { title: 'Bid-Offer' }
      Plotly.newPlot('priceChart', [traceBid, traceAsk], layoutPrice)
      const traceHist = { x: spread, type: 'histogram' }
      const layoutHist = { title: 'Spread bps frequency' }
      Plotly.newPlot('historgramChart', [traceHist], layoutHist)
      const traceSpread = { x: dateTime, y: spread, type: 'scatter' }
      const layoutSpread = { title: 'Spread bps' }
      Plotly.newPlot('spreadChart', [traceSpread], layoutSpread)
      const traceViolin = { y: spread, type: 'violin', points: 'none', box: { visible: true }, boxpoints: false, line: { color: 'black' }, fillcolor: '#8dd3c7', opacity: 0.6, meanline: { visible: true }, x0: 'returns' }
      const layoutViolin = { title: 'Spread bps distribution', yaxis: { zeroline: false } }
      Plotly.newPlot('violinChart', [traceViolin], layoutViolin)
      const balanceSmooth = balance.map((x, i) => {
        if (i === 0) {
          return x
        } else {
          const start = Math.max(0, i - 1000)
          return balance.slice(start, i).reduce((accumulator, current) => accumulator + current)
        }
      })
      const traceBalance = { x: dateTime, y: balance, type: 'scatter' }
      const layoutBalance = { title: 'Book balance' }
      Plotly.newPlot('balanceChart', [traceBalance], layoutBalance)
      const traceBalanceSmooth = { x: dateTime, y: balanceSmooth, fill: 'tozeroy', type: 'scatter' }
      const layoutBalanceSmooth = { title: 'Book balance 1,000 ticks' }
      Plotly.newPlot('balanceSmoothChart', [traceBalanceSmooth], layoutBalanceSmooth)
    },
    schemaFileRegister: async function () {
      this.schemaFile = document.getElementById('inputSchema').files[0]
    },
    schemaFileProcess: async function () {
      this.schemaFileContent = await this.schemaFile.text()
      this.schema = _.split(this.schemaFileContent, ',')
      _.each(this.schema, (value, index) => {
        this.col[value] = index
      })
      _.each(this.tests, (value, index) => {
        this.test[value.id] = index
      })
      this.steps.data = true
    },
    schemaCancel: function () {
      this.schema = []
      this.schemaFileContent = null
      this.steps.data = false
    },
    dataFileRegister: function () {
      this.file = document.getElementById('input').files[0]
    },
    dataFileReload: function () {
      this.completed = false
      this.lines = null
      dateTime = []
      bidPrice = []
      bidSize = []
      askPrice = []
      askSize = []
      spread = []
      balance = []
      this.steps.data = false
      this.steps.loadingData = false
      this.steps.loadedData = false
      this.file = null
      this.stream = null
      this.reader = null
      this.schema = []
      this.schemaFileContent = null
      this.steps.schema = true
    },
    dataFileStream: async function () {
      this.steps.schema = false
      this.steps.data = false
      this.steps.loadingData = true
      this.stream = await this.file.stream()
      this.reader = await this.stream.getReader()
      this.show = true
      await async.until(async.asyncify(this.testStream), async.asyncify(this.processChunk))
      this.steps.loadingData = false
      this.steps.loadedData = true
      this.lines = dateTime.length
      this.analyticsPrepare()
    },
    processChunk: async function () {
      await this.log()
      const chunk = await this.reader.read()
      if (chunk.done) {
        console.log('Stream complete')
        this.completed = true
        return
      }
      this.parser.write(chunk.value)
      this.lines = dateTime.length
    },
    testStream: function () {
      return this.completed
    },
    log: async function () {
      await delay(1)
      return true
    }
  }
}
</script>
<style lang="scss">
/*
Original highlight.js style (c) Ivan Sagalaev <maniac@softwaremaniacs.org>
*/

.hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  background: #F0F0F0;
}

/* Base color: saturation 0; */

.hljs,
.hljs-subst {
  color: #444;
}

.hljs-comment {
  color: #888888;
}

.hljs-keyword,
.hljs-attribute,
.hljs-selector-tag,
.hljs-meta-keyword,
.hljs-doctag,
.hljs-name {
  font-weight: bold;
}

/* User color: hue: 0 */

.hljs-type,
.hljs-string,
.hljs-number,
.hljs-selector-id,
.hljs-selector-class,
.hljs-quote,
.hljs-template-tag,
.hljs-deletion {
  color: #880000;
}

.hljs-title,
.hljs-section {
  color: #880000;
  font-weight: bold;
}

.hljs-regexp,
.hljs-symbol,
.hljs-variable,
.hljs-template-variable,
.hljs-link,
.hljs-selector-attr,
.hljs-selector-pseudo {
  color: #BC6060;
}

/* Language color: hue: 90; */

.hljs-literal {
  color: #78A960;
}

.hljs-built_in,
.hljs-bullet,
.hljs-code,
.hljs-addition {
  color: #397300;
}

/* Meta color: hue: 200 */

.hljs-meta {
  color: #1f7199;
}

.hljs-meta-string {
  color: #4d99bf;
}

/* Misc effects */

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}
/*
github.com style (c) Vasily Polovnyov <vast@whiteants.net>
*/

.hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  color: #333;
  background: #f8f8f8;
}

.hljs-comment,
.hljs-quote {
  color: #998;
  font-style: italic;
}

.hljs-keyword,
.hljs-selector-tag,
.hljs-subst {
  color: #333;
  font-weight: bold;
}

.hljs-number,
.hljs-literal,
.hljs-variable,
.hljs-template-variable,
.hljs-tag .hljs-attr {
  color: #008080;
}

.hljs-string,
.hljs-doctag {
  color: #d14;
}

.hljs-title,
.hljs-section,
.hljs-selector-id {
  color: #900;
  font-weight: bold;
}

.hljs-subst {
  font-weight: normal;
}

.hljs-type,
.hljs-class .hljs-title {
  color: #458;
  font-weight: bold;
}

.hljs-tag,
.hljs-name,
.hljs-attribute {
  color: #000080;
  font-weight: normal;
}

.hljs-regexp,
.hljs-link {
  color: #009926;
}

.hljs-symbol,
.hljs-bullet {
  color: #990073;
}

.hljs-built_in,
.hljs-builtin-name {
  color: #0086b3;
}

.hljs-meta {
  color: #999;
  font-weight: bold;
}

.hljs-deletion {
  background: #fdd;
}

.hljs-addition {
  background: #dfd;
}

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}
</style>
